"use client";

import { LogError } from "@/actions/LogError";
import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PillButton from "./shared/PillButton";
import Link from "next/link";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    LogError({
      message: error.message,
      stack: error.stack,
      name: error.name,
      digest: error.digest,
    });
  }, [error]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <ErrorOutlineIcon
          sx={{
            fontSize: "100px",
          }}
        />
        <Typography component="h1" variant="h4">
          Sorry, we seem to be having problems
        </Typography>
        <Typography>
          For immediate assistance, please{" "}
          <a href="mailto:support@horsezone.com.au">Contact Support</a>.
        </Typography>
        <Typography>
          Otherwise, you might have better luck trying again, or coming back
          later.
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 2,
          }}
        >
          <PillButton
            sx={{
              backgroundColor: "grey.200",
            }}
            onClick={
              // Attempt to recover by trying to re-render the segment
              () => reset()
            }
          >
            Try again
          </PillButton>
          <Link href="/">
            <PillButton
              sx={{
                backgroundColor: "grey.200",
              }}
            >
              Go Home
            </PillButton>
          </Link>
        </Box>
      </Box>
    </Box>
  );
}